import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import Profile from "./auth/profile/reducer"

//crypto
import crypto from "./crypto/reducer"

//invoices
import invoices from "./invoices/reducer"

//projects
import projects from "./projects/reducer"

//tasks
import tasks from "./tasks/reducer"


const rootReducer = combineReducers({
  Layout,
  Login,
  Account,
  Profile,
  crypto,
  invoices,
  projects,
  tasks,

})

export default rootReducer
